(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@/utils/time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@/utils/time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.time);
    global.salesRecords = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _time) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    filters: {
      formateTime: _time.formateTime
    },
    data: function data() {
      return {
        list: []
      };
    },
    created: function created() {
      this.initList();
    },
    methods: {
      // 初始化
      initList: function initList() {
        var vm = this;
        vm.list = vm.$route.params.expressDeliveryInfo;

        if (vm.list.length == 0) {
          vm.list = [{
            context: '该快递暂无揽件信息',
            last: true
          }];
        }
      }
    }
  };
  _exports.default = _default;
});